export default {
    dashboard: `Dashboard`,
    people: 'People',
    administrators: `Administrators`,
    customer: `Customers`,
    suppliers: `Suppliers`,
    retailers: `Retailers`,
    drivers: `Drivers`,
    workers: `Workers`,
    members: 'Members',
    products: 'Products',
    items: 'Items',
    productItems: 'Product Items',
    categories: 'Categories',
    brands: 'Brands',
    uoms: 'Uoms',
    documents: 'Documents',
    sales: 'Sales',
    salesOrders: 'Sales Orders',
    perfomaSales: 'Perfoma Sales',
    // 'Sales Invoices': 'Sales Invoices',
    salesInvoices: 'Sales Invoices',
    // 'Delivery Orders': 'Delivery Orders',
    deliveryOrders: 'Delivery Orders',

    cashSales: 'Cash Sales',
    salesDebitNotes: 'Sales Debit Notes',
    salesCreditNotes: 'Sales Credit Notes',
    replacementDeliveries: 'Replacement Deliveries',
    retailCashSales: 'Retail Cash Sales',
    retailPrescription: 'Retail Prescription',
    purchases: 'Purchases',
    purchaseOrders: 'Purchase Orders',
    purchaseReturns: 'Purchase Returns',
    purchaseInvoices: 'Purchase Invoices',

    parcel: 'Parcel',
    warehouse: 'Warehouse',
    // 'Item Receives': 'Item Receives',
    itemReceives: 'Item Receives',
    itemTransfers: 'Item Transfers',
    itemRelocates: 'Item Relocates',
    itemTransforms: 'Item Transforms',
    itemIssues: 'Item Issues',
    itemAdjustments: 'Item Adjustments',
    stockTakes: 'Stock Takes',
    transferReturns: 'Transfer Returns',
    transferRequisitions: 'Transfer Requisitions',
    pickOrders: 'Pick Orders',
    others: 'Others',
    operations: 'Operations',
    itemRelocateThreshold: 'Item Relocate Threshold',
    itemReorderThreshold: 'Item Reorder Threshold',
    examineInventory: 'Examine Inventory',
    reports: 'Reports',
    delivery: 'Delivery',
    inventories: 'Inventories',

    logistics: 'Logistics',
    transporters: 'Transporters',
    // 'Delivery Trips': 'Delivery Trips',
    deliveryTrips: 'Delivery Trips',
    repositories: 'Repositories',
    containers: 'Containers',
    packages: 'Packages',
    packPackages: 'Pack Packages',
    queryPackages: 'Query Packages',
    groups: 'Groups',
    // 'Administrator Group': 'Administrator Group',
    administratorGroups: 'Administrator Group',
    // 'Customer Group': 'Customer Group',
    customerGroups: 'Customer Group',
    // 'Supplier Group': 'Supplier Group',
    supplierGroups: 'Supplier Group',
    settings: 'Settings',
    // 'Roles and Permissions': 'Roles and Permission',
    rolesAndPermissions: 'Roles and Permission',
    business: 'Business',
    locations: 'Locations',
    regions: 'Regions',
    countryAndRegions: 'Country & Regions',
    emailGateway: 'Email Gateway',
    // 'Injection Props': 'Injection Props',
    injectionProps: 'Injection Props',
    // 'Shipping Rates': 'Shipping Rates',
    customFields: 'Custom Fields',
    auditTrails: 'Audit Trails',
    taxRates: 'Tax Rates',
    shippingRates: 'Shipping Rates',
    projectProps: 'Project Props',
    schedulers: 'Schedulers',
    tasks: 'Tasks',
    logs: 'Logs',
    requests: 'Requests',
    console: 'Console',
    wallets: 'Wallets',
    transactions: 'Transactions',
    walletTransactions: 'Wallet Transactions',
    walletRequests: 'Wallet Requests',
    userApiKeys: 'User API Keys',

    transportType: 'Transport Type',
}